"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchOverview = fetchOverview;
exports.fetchTimeseries = fetchTimeseries;
exports.fetchByEndpoint = fetchByEndpoint;
exports.fetchSlowQueries = fetchSlowQueries;
const http_1 = require("../../http");
const BASE = `${http_1.ApiBaseUrl}`;
function qs(params) {
    const q = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
        if (v === undefined || v === null || v === '')
            return;
        q.append(k, String(v));
    });
    return q.toString();
}
function get(path_1) {
    return __awaiter(this, arguments, void 0, function* (path, params = {}) {
        const url = `${BASE}${path}${Object.keys(params).length ? '?' + qs(params) : ''}`;
        const res = yield fetch(url, { credentials: 'same-origin' });
        if (!res.ok)
            throw new Error(`${res.status} ${res.statusText}`);
        return res.json();
    });
}
function fetchOverview(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return get('metrics/orm/overview', params);
    });
}
function fetchTimeseries(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return get('metrics/orm/timeseries', params);
    });
}
function fetchByEndpoint(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return get('metrics/orm/by-endpoint', params);
    });
}
function fetchSlowQueries(params) {
    return __awaiter(this, void 0, void 0, function* () {
        return get('metrics/orm/slow-queries', Object.assign(Object.assign({}, params), { limit: 50 }));
    });
}
